import { useEffect, useRef, useState } from "react"
import { useLazyFetchSubscriptionDetailsQuery } from "../../redux/queries"
import { AdvisorSession, SubscriptionDetails } from "../../types"

export const useSubscriptionMap = (sessions: AdvisorSession[]) => {
  const [triggerSub] = useLazyFetchSubscriptionDetailsQuery()
  const fetchedIds = useRef(new Set<string>())
  const [subscriptionMap, setSubscriptionMap] = useState<
    Record<string, SubscriptionDetails>
  >({})

  useEffect(() => {
    const newIds = sessions
      .map(s => s.subscriptionId)
      .filter((id): id is string => !!id && !fetchedIds.current.has(id))

    if (!newIds.length) return

    newIds.forEach(id => fetchedIds.current.add(id))
    Promise.all(
      newIds.map(id =>
        triggerSub({ id })
          .unwrap()
          .catch(() => null)
      )
    ).then(results => {
      const updates: Record<string, SubscriptionDetails> = {}
      results.forEach((data, i) => {
        if (data) updates[newIds[i]] = data
      })
      if (Object.keys(updates).length) {
        setSubscriptionMap(prev => ({ ...prev, ...updates }))
      }
    })
  }, [sessions, triggerSub])

  return subscriptionMap
}
